/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Household_UnregisterInputs */

const fr_household_unregister = /** @type {(inputs: Household_UnregisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désinscrire`)
};

/**

* @param {Household_UnregisterInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const household_unregister = /** @type {((inputs?: Household_UnregisterInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_UnregisterInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_household_unregister(inputs)
});